<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="lease?.tenant_name"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded && lease && summary) {

      <!-- Lease summary: who + where on top, the money below the divider, actions last.
           Balance sits a step below the tenant name so the name still reads as the title. -->
      <tidy-card>
        <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
          <tidy-initials-icon [fullName]="lease.tenant_name" />
          <tidy-text [header]="lease.tenant_name" [translate]="false" />
          <tidy-text [body]="lease.status" [translate]="false" [ngStyle]="{ color: statusTextColor }" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/home-outline.svg'" class="body-size" />
          <tidy-text [helper]="propertyLabel" [translate]="false" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/calendar-outline.svg'" class="body-size" />
          <tidy-text
            [helper]="(lease.start_date | date:'MMM d, yyyy') + ' – ' + (lease.end_date | date:'MMM d, yyyy')"
            [translate]="false" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/cash-outline.svg'" class="body-size" />
          <tidy-text [helper]="rentDetailLabel" [translate]="false" />
        </tidy-row>
        @if (liabilityLabel) {
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/svg/people-outline.svg'" class="body-size" />
            <tidy-text [helper]="liabilityLabel" [translate]="false" [ngStyle]="{ color: '#1a8e9c' }" />
          </tidy-row>
        }

        <tidy-divider />

        <tidy-row [alignLastItemRight]="true" class="extra-top-padding vertical-align-center">
          <tidy-text [body]="'Balance'" />
          <tidy-text [heavyBody]="balanceText" [translate]="false" [ngStyle]="{ color: balanceTextColor }" />
        </tidy-row>
        <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
          <tidy-text [helper]="'Deposit held'" />
          <tidy-text [helper]="'$' + lease.deposit_held.toLocaleString('en-US')" [translate]="false" />
        </tidy-row>

        @if (summary.balance > 0) {
          <tidy-card-button (action)="recordPayment()">
            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/img/dollar.svg'" class="body-size" />
              <tidy-text [body]="'Record Payment'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="assessLateFee()">
            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/svg/alarm-outline.svg'" class="body-size" />
              <tidy-text [body]="'Add Late Fee'" />
            </tidy-row>
          </tidy-card-button>
        }
        <tidy-card-button (action)="sendStatement()">
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/svg/document-text-outline.svg'" class="body-size" />
            <tidy-text [body]="'Send Statement'" />
          </tidy-row>
        </tidy-card-button>
      </tidy-card>

      <tidy-row>
        <tidy-text [actionBody]="'Copy tenant portal link'" (action)="copyPortalLink()" class="white-link" />
      </tidy-row>

      <tidy-row class="extra-top-padding">
        <tidy-text
          [helper]="('Late fee policy: $' | translate) + lease.late_fee_amount + (' flat, auto-applied ' | translate) + lease.late_fee_grace_days + (' days after the due date.' | translate)" />
      </tidy-row>

      <!-- Ledger (statement) -->
      <tidy-row><tidy-text [title]="'Ledger'" /></tidy-row>

      <!-- One compact card per entry on every breakpoint — a statement reads better as a
           running list than as a table, and it stays legible inside the side panel. -->
      @for (entry of ledgerViews; track entry.id) {
        <tidy-card>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="entry.description" [translate]="false" />
            <tidy-text [body]="entry.amountLabel" [translate]="false" [ngStyle]="{ color: entry.amountColor }" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
            <tidy-text [helper]="entry.metaLabel" [translate]="false" />
            <tidy-text [helper]="entry.balanceLabel" [translate]="false" />
          </tidy-row>
        </tidy-card>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
